export const MAP_SALE = '/map?status=A&listingType=Sale';
export const MAP_RENT = '/map?status=A&listingType=Rent';
